import { ApplicationListMakati } from "./components/ApplicationListMakati"
import { ApplicationListMakati as ApplicationListMakatiTvet } from "./components/ApplicationListMakatiTvet"
import { ApplicationListSTD } from "./components/ApplicationListSTD"
import { ApplicationListCDLI } from "./components/ApplicationListCDLI";
import { ApplicationListMabalacat } from "./components/ApplicantListMabalacat";

export function ApplicationList() {

   var subdomain = localStorage.getItem("lms-subdomain");

   const applicationList = () => {
      const components = {
         'dbti-makati': ApplicationListMakati,
         'localhost': ApplicationListMakati,
         'dbtishs-edu': ApplicationListMakati,
         'casadellibroinc': ApplicationListCDLI,
         'makati': ApplicationListMakatiTvet,
         'mabalacat': ApplicationListMabalacat
      };

      const Component = components[subdomain] || ApplicationListSTD;
      return <Component />;
   };

   return (
      <>
         {
            applicationList()
         }
      </>
   )
}
